__turbopack_context__.v({
  "accent-text": "accent-text-module__fKTpLG__accent-text",
});
